import type { MovingAverage } from '../data/types';

export function assertMovingAverage(value: MovingAverage | undefined): void {
  if (value && (!Number.isInteger(value.window) || value.window <= 0)) {
    throw new RangeError('La finestra della media mobile deve essere un intero positivo.');
  }
}

export function trailingAverage(values: readonly number[], window: number): number[] {
  let sum = 0;
  return values.map((value, index) => {
    sum += value;
    if (index >= window) sum -= values[index - window] ?? 0;
    return Math.round(sum / Math.min(index + 1, window));
  });
}

export function inSet<T>(value: T, set: ReadonlySet<T> | undefined): boolean {
  return set === undefined || set.has(value);
}
